import { i as v, x as o, r as h, n as l } from "./abstract-base-CzLmw6_x.js";
import { e as m } from "./class-map-DVI1Gii9.js";
import { B as f } from "./table-cell-DSuHhZzg.js";
import { B as u } from "./beacon-primitive-ChVMWFlW.js";
import { p as y } from "./lifecycle-decorators-CUsT9aHq.js";
import { d as w, b as x } from "./query-assigned-K46zQIzj.js";
var i = /* @__PURE__ */ ((r) => (r.TEXT = "text", r.NUMERAL = "numeral", r.DATE = "date", r.ICONS = "icons", r))(i || {});
const z = v`[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-unit-base))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-unit-atomic)}.beacon-table-record__footnote{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-record] p{margin:0}[beacon-tag-name=beacon-table-record] svg{block-size:var(--beacon-table-record-icon-size);inline-size:var(--beacon-table-record-icon-size)}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]{padding:var(--beacon-unit-atomic)}`, C = v`:host{color:var(--beacon-color-text-default-on-light);inline-size:inherit;word-break:initial}.record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-default);--margin-start: var(--beacon-table-record-space-margin-inline-start-default);display:flex;margin-inline-end:var(--margin-end);margin-inline-start:var(--margin-start)}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-secondary);--margin-start: var(--beacon-table-record-space-margin-inline-start-secondary)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-sorting)}.record-numeral{align-items:center;display:flex;flex-wrap:wrap;gap:calc(.125 * var(--beacon-unit-base)) calc(.75 * var(--beacon-unit-base));justify-content:end;margin-block-end:calc(.125 * var(--beacon-unit-base))}.record-na{color:var(--beacon-colors-light-grey-1)}.record-cell{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));flex-grow:1;margin-block-start:var(--beacon-unit-subatomic)}.record-cell:is(.numeral,.date){text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold>:is(.record-numeral,.record-na),.record-cell.sorted>:is(.record-numeral,.record-na){font-weight:var(--beacon-font-weight-bold)}.record-delta{align-items:center;display:flex}.record-delta-value{color:var(--beacon-colors-medium-grey-1)}.record-delta-icon{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewbox='0 0 16 16' style='fill: %23248647; transform: rotate(180deg);'%3E%3Cpolygon points='4,5 8,11 12,5'/%3E%3C/svg%3E");block-size:var(--beacon-unit-base);display:inline-block;inline-size:var(--beacon-unit-base)}.record-delta-icon.negative{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewbox='0 0 16 16' style='fill: %23DD3636;'%3E%3Cpolygon points='4,5 8,11 12,5'/%3E%3C/svg%3E")}.record-footnote{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default));color:var(--beacon-colors-medium-grey-1);margin:0}.empty{display:none}.action-zone:not(.empty){display:grid;grid-template-rows:1fr 1fr;inline-size:calc(2.5 * var(--beacon-unit-base));margin-block-start:calc(var(--beacon-unit-subatomic) + var(--beacon-cell-space-padding));place-items:center}.hide{display:none}`;
var D = Object.defineProperty, E = Object.getOwnPropertyDescriptor, t = (r, s, n, c) => {
  for (var a = c > 1 ? void 0 : c ? E(s, n) : s, d = r.length - 1, p; d >= 0; d--)
    (p = r[d]) && (a = (c ? p(s, n, a) : p(a)) || a);
  return c && a && D(s, n, a), a;
};
const g = "beacon-table-record", $ = o`&#8212`, b = class b extends u(f) {
  constructor() {
    super(...arguments), this.beaconTagName = g, this.variant = i.TEXT, this.sorted = !1, this.hasActionZoneContent = !1;
  }
  static get styles() {
    return [super.styles, C];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, z];
  }
  /**
   * Getter for deltaValue
   *
   * @returns parsed delta string value
   */
  get deltaValue() {
    return parseFloat(this.delta);
  }
  /**
   * Returns sign of delta to determine delta icon styles
   *
   * @returns true/false for positive/negative respectively
   */
  get deltaPositive() {
    return this.deltaValue ? this.deltaValue > 0 : this.slottedDelta > 0;
  }
  setActionZoneStatus() {
    this.hasActionZoneContent = this.actionZone.length > 0;
  }
  deltaSlotChange(s) {
    let n;
    this.slottedDeltaNodes.length > 0 && (n = this.slottedDeltaNodes.map((c) => {
      var a, d;
      return (d = (a = c.textContent) == null ? void 0 : a.trim()) != null ? d : "";
    }).join("")), n && (this.slottedDelta = parseFloat(n));
  }
  /**
   * Renders slot element with default styles
   * @returns default empty slot styles
   */
  renderSlot() {
    return o`<slot><span class="record-na">${$}</span></slot>`;
  }
  /**
   * Renders numeral and delta with proper spacing
   * @returns HTML template for numeral element in numeral record
   */
  renderNumeral() {
    const s = (this.delta || this.slottedDelta) && !this.hideDeltaIcon ? o`<span class="record-delta-icon ${this.deltaPositive ? "" : "negative"}"></span>` : o``, n = {
      "record-delta-value": !0,
      hide: !this.slottedDelta && !this.delta || this.hideDeltaValue
    };
    return o` <span class="record-delta"> ${s}<span class=${m(n)}><slot name="delta" @slotchange=${this.deltaSlotChange}>${this.delta}</span></slot> </span
      >${this.renderSlot()}`;
  }
  /**
   * Conditionally renders cell contents
   * @returns HTML template according to variant type
   */
  renderCell() {
    switch (this.variant) {
      case i.NUMERAL:
        return o`<div class="record-numeral">${this.renderNumeral()}</div>
          <p class="record-footnote"><slot name="footnote">${this.footnote}</slot></p>`;
      case i.DATE:
      case i.TEXT:
      case i.ICONS:
      default:
        return o`${this.renderSlot()}`;
    }
  }
  /**
   * Default render function
   * @returns HTML template for table record component
   */
  render() {
    return o`<div class="record-cell-wrapper" part="cell-wrapper">
      <div class="has-cell-padding record-cell ${this.bold ? "bold" : ""} ${this.sorted ? "sorted" : ""} ${this.variant}" part="cell">
        ${this.renderCell()}
      </div>
      ${this.variant === i.NUMERAL ? o`<div class="action-zone ${m({ empty: !this.hasActionZoneContent })}" part="action-zone">
            <slot name="action-zone"></slot>
          </div>` : o``}
    </div>`;
  }
};
b.tagName = g;
let e = b;
t([
  l({ reflect: !0, alternateSlot: "footnote", sync: !1 })
], e.prototype, "footnote", 2);
t([
  l({ reflect: !0 })
], e.prototype, "variant", 2);
t([
  l({ reflect: !0, alternateSlot: "delta", sync: !1 })
], e.prototype, "delta", 2);
t([
  h()
], e.prototype, "slottedDelta", 2);
t([
  w({ flatten: !0, slot: "delta" })
], e.prototype, "slottedDeltaNodes", 2);
t([
  l({ attribute: "sort-value", reflect: !0 })
], e.prototype, "sortValue", 2);
t([
  l({ type: Boolean, reflect: !0 })
], e.prototype, "bold", 2);
t([
  l({ type: Boolean, reflect: !0 })
], e.prototype, "sorted", 2);
t([
  l({ type: Boolean, reflect: !0, attribute: "hide-delta-icon" })
], e.prototype, "hideDeltaIcon", 2);
t([
  l({
    type: Boolean,
    reflect: !0,
    attribute: "hide-delta-value"
  })
], e.prototype, "hideDeltaValue", 2);
t([
  h()
], e.prototype, "hasActionZoneContent", 2);
t([
  x({ slot: "action-zone" })
], e.prototype, "actionZone", 2);
t([
  y
], e.prototype, "setActionZoneStatus", 1);
export {
  e as B,
  i as T
};
